import "../Styles/About.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUnity, faReact, faAngular, faNode, faWordpress, faBootstrap, faHtml5, faJs, faCss3Alt } from '@fortawesome/free-brands-svg-icons';
import csharpIcon from "../Images/icons/csharpIcon.png";
import gdscript from "../Images/icons/gdscripticon.png";
import godoticon from "../Images/icons/godoticon.png";
import typescripticon from "../Images/icons/typescripticon.png";
import mysqlicon from "../Images/icons/mysqlicon.png";
import mongodbicon from "../Images/icons/mongodbicon.png";
import blendericon from "../Images/icons/blendericon.png";
import kritaicon from "../Images/icons/kritaicon.png";
import audacityicon from "../Images/icons/audacityicon.png";

function About() {
  const experiences = [
    { name: "Game Design", startDate: new Date(2023, 7, 1), description: "I design mechanics and levels for my own indie games. Using my strong problem-solving skills, I carefully craft each element and mechanic to be bug-free and create an immersive great experience." },
    { name: "Unity", startDate: new Date(2023, 7, 1), description: "Developing 2D & 3D games in unity engine." },
    { name: "Godot", startDate: new Date(2024, 9, 1), description: "Developing 2D & 3D games in godot engine." },
    { name: "Narrative Design", startDate: new Date(2023, 7, 1), description: "Creating interactive stories for my games. As a writer, I strive to deliver fascinating narratives through gameplay, with every game containing a story waiting to be discovered." },
    { name: "Game Testing & Analysis", startDate: new Date(2020, 10, 1), description: "I analyze gameplay, mechanics, and storytelling in every game I play. I have a unique, natural talent for spotting bugs and noticing even the smallest details." }
  ];

  const calculateYears = (startDate) => {
    const now = new Date();
    const diffMs = now - startDate;
    const diffYears = diffMs / (1000 * 60 * 60 * 24 * 365.25);
    return Math.floor(diffYears);
  };

  return (
    <div className="about-page">
      
      {/* Profile Section */}
      <div className="profile-section">
        <div className="image-placeholder"></div>
        <div className="text-box">
          <p>Hi, I'm osher volotker, a passionate gamer for games and stories, after so many years with love for video games. I became a developer to build games, and help others build great games. Apart from that I also have the passion for stories, both for games and film. I have experience with unity and Godot engines and a variety of tools. My studio currently include only myself, but hopefully it will grow and more great developers could join in. I focus mainly in video games and film for career paths. You are welcome to check out my site and contact me if you wish to hire me or collaborate. I am a very creative person with deep analysis thinking, a team player, organized, and determined. any story you have to tell the world whenever its a game or a film I will be happy to work with you. You name it, I make it.</p>
        </div>
      </div>



      {/* Education Section */}
      <div className="education-section">
        <h2>Education</h2>
        <div className="education-details">
          <div className="education-column">
            <h3>Game Development</h3>
            <p>School: Hasifa communication and digital</p>
            <p>Year: 2020-2021</p>
            <p>Certificate: Game design and development</p>
          </div>
          <div className="education-column">
            <h3>Web Development</h3>
            <p>School: Hacker U</p>
            <p>Year: 2022-2023</p>
            <p>Certificate: Web design and development</p>
          </div>
          <div className="education-column">
            <h3>Film</h3>
            <p>School: Skillshare</p>
            <p>Year: 2023</p>
            <p>Online Certificate: Screenwriting</p>
          </div>
          <div className="education-column">
            <h3>Game Development</h3>
            <p>School: Hotmart Club</p>
            <p>Year: 2023</p>
            <p>Online Certificate: Pro Indie Dev</p>
          </div>
        </div>
      </div>



      {/* Experience Section */}
 <div className="experience-section">
  <h2>Experience</h2>
  <div className="experience-details">
    {experiences.map((exp, i) => (
      <div className="experience-column" key={i}>
        <div className="experience-item">
          <div className="experience-left">
            <strong>{exp.name}</strong>
            <span>{exp.startDate ? calculateYears(exp.startDate) + " Years" : "∞"}</span>
          </div>
          <div className="experience-right">
            <p>{exp.description}</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>


      {/* Tools Section */}
      <div className="tools-section">
        <h2>Tools and Frameworks</h2>
        <div className="tools-details">
          <div className="tool-item">
            <div className="tool-title"><h3>Web</h3></div>
            <div className="tools-symbols">
              <FontAwesomeIcon icon={faReact} size='2x' className='icon' title="React" />
              <FontAwesomeIcon icon={faAngular} size='2x' className='icon' title="Angular" />
              <FontAwesomeIcon icon={faNode} size='2x' className='icon' title="NodeJS" />
              <FontAwesomeIcon icon={faWordpress} size='2x' className='icon' title="WordPress" />
              <FontAwesomeIcon icon={faBootstrap} size='2x' className='icon' title="Bootstrap" />
              <FontAwesomeIcon icon={faHtml5} size='2x' className='icon' title="HTML" />
              <FontAwesomeIcon icon={faJs} size='2x' className='icon' title="JavaScript" />
              <FontAwesomeIcon icon={faCss3Alt} size='2x' className='icon' title="CSS" />
              <img src={typescripticon} alt="typescript" className="icon" style={{ width: '35px', height: '35px' }} title="TypeScript" />
              <img src={mysqlicon} alt="mysql" className="icon" style={{ width: '35px', height: '35px' }} title="MySQL" />
              <img src={mongodbicon} alt="mongodb" className="icon" style={{ width: '30px', height: '35px' }} title="MongoDB" />
            </div>
          </div>

          <div className="tool-item">
            <div className="tool-title"><h3>Gaming</h3></div>
            <div className="tools-symbols">
              <FontAwesomeIcon icon={faUnity} size='2x' className='icon' title='Unity' />
              <img src={csharpIcon} alt="C#" className="icon" style={{ width: '38px', height: '38px' }} title="C#" />
              <img src={gdscript} alt="gdscript" className="icon" style={{ width: '65px', height: '30px' }} title="GDscript" />
              <img src={godoticon} alt="godot" className="icon" style={{ width: '38px', height: '38px' }} title="Godot" />
              <img src={blendericon} alt="blender" className="icon" style={{ width: '38px', height: '38px' }} title="Blender" />
              <img src={kritaicon} alt="krita" className="icon" style={{ width: '38px', height: '38px' }} title="Krita" />
              <img src={audacityicon} alt="audacity" className="icon" style={{ width: '38px', height: '38px' }} title="Audacity" />
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default About;
